import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import '@synergycms_core/less/fonts.css';
import styleFile from './App.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import Modal from '@synergycms_core/components/generic/Modal';
import StepManager from '../../containers/stepManager/StepManager.jsx';
import { AVAIL_LIFETIME } from '../../config/constants';
import { compose, contains} from 'ramda';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { connect } from 'react-redux';
import TimeoutModal  from '../../components/functional/Timeout/index.jsx'
import Header from '../../components/functional/Header';
import Footer from '../../components/functional/Footer/Footer.jsx';

import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
// TODO canviar els div per RICHTEXT, afegir l'icona de la capçalera i afegir les funcionalitats del boto i els noms de classe.

class App extends React.Component {
  static displayName = 'App';

  constructor(props) {
    super(props);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.reload = window.location.reload.bind(window.location);

    this.state = {
      userIsIdle: false
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    return (this.activeIdleTimer() && nextState.userIsIdle) || (nextProps.config.availLifeTime !== this.props.config.availLifeTime);
  };

  activeIdleTimer = () => !contains(this.props.config.currentStep, ['confirmation', 'cancelation', 'newCof']);

  render() {
    const { classes } = this.props.theme.styles;
    const activeIdleTimer = this.activeIdleTimer();
    const lifetime =  this.props.config.availLifeTime ?  this.props.config.availLifeTime : AVAIL_LIFETIME;
    return (
      <div className={[classes.app, classes.baseReset].join(' ')}>
        {activeIdleTimer && (
          <IdleTimer element={document} onActive={this.onActive} onIdle={this.onIdle} timeout={lifetime} />
        )}
        <Header innerStyle={[classes.header]} />
        <StepManager />
        {this.state.userIsIdle && (
          <Modal
            innerStyle={classes.timeoutModalContainer}
            contentStyle={classes.timeoutModalContent}
            instantToggle={true}
            filterModal={true}
            preventToggleModal={true}
            popover={
              <TimeoutModal />
            }
            typeModal={'timeoutTooltip'}
            defaultStyle={false}
          />
        )}
        <Footer />
      </div>
    );
  }

  _onActive(e) {
    this.setState({ userIsIdle: false });
  }

  _onIdle(e) {
    this.setState({ userIsIdle: true });
  }
}

const mapStateToPropsApp = (store, ownProps) => {
  let hotelId = null
  const webType = store.getIn(['customer', 'web_type'], false);
  if(webType === "WI")
     hotelId = store.getIn(['customer', 'current_hotel']);
  const engineConfigs = contextualizeAppConfig(store, hotelId);

  return {
    currentStep: store.getIn(['customer', 'step', 'current_step', 'code']),
    availLifeTime: engineConfigs.get('avail_life_time'),
  };
};

export default compose(
  connect(mapStateToPropsApp),
  PropertyManager([
    'currentStep',
    'availLifeTime'
  ]),
  withThemeJSS({ styleFile, link: true })
)(App);
